import { ArrayFieldTemplateProps } from '@rjsf/utils';

const ReadOnlyArrayFieldTemplate = ({ items }: ArrayFieldTemplateProps) => {
  return (
    <div>
      {items.map((item) => (
        <div key={item.key} style={{ marginBottom: '10px' }}>
          <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{item.children}</div>
        </div>
      ))}
    </div>
  );
};

export default ReadOnlyArrayFieldTemplate;
